"use client"

import { useRouter } from "next/navigation"

const backLinkClass =
  "cursor-pointer text-sm text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1"

export type BackLinkProps = {
  className?: string
}

export default function BackLink({ className }: BackLinkProps) {
  const router = useRouter()
  return (
    <button
      type="button"
      onClick={() => router.back()}
      className={`${backLinkClass} ${className ?? ""}`.trim()}
    >
      ← retour
    </button>
  )
}
